import { GitCommit, X } from "lucide-react";
import CommitDiffPanel from "./CommitDiffPanel";

/* ── Re-export DiffCommit for consumers ── */

export interface DiffCommit {
  id: string;
  sequence: number;
  parentId?: string | null;
  message?: string | null;
  authorName?: string | null;
  createdAt?: string | null;
  changes?: { id?: string; action: string; filePath: string; contentHash?: string | null }[];
}

interface CommitDiffModalProps {
  commit: DiffCommit;
  parentCommitId: string | null;
  projectSlug: string;
  branchId: string;
  onClose: () => void;
}

export default function CommitDiffModal({ commit, parentCommitId, projectSlug, branchId, onClose }: CommitDiffModalProps) {
  const msg = commit.message || "(no message)";
  const dateStr = commit.createdAt ? new Date(commit.createdAt).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-2xl w-[95vw] max-w-[1400px] h-[90vh] flex flex-col" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-slate-100 shrink-0">
          <div className="flex items-center gap-2.5">
            <GitCommit className="size-3.5 text-indigo-500" />
            <span className="text-[14px] font-semibold text-slate-800 truncate max-w-[400px]">{msg}</span>
            <span className="text-[10px] text-slate-400 font-mono">#{commit.sequence}</span>
          </div>
          <div className="flex items-center gap-2.5">
            {commit.authorName && <span className="text-[11px] text-slate-500">{commit.authorName}</span>}
            {dateStr && <span className="text-[10px] text-slate-400">{dateStr}</span>}
            <button onClick={onClose} className="p-1 rounded hover:bg-slate-100 transition-colors">
              <X className="size-4 text-slate-400" />
            </button>
          </div>
        </div>

        {/* Body — delegated to CommitDiffPanel */}
        <div className="flex-1 overflow-hidden min-h-0 flex flex-col">
          <CommitDiffPanel
            commitA={parentCommitId}
            commitB={commit.id}
            projectSlug={projectSlug}
            branchId={branchId}
            beforeLabel="Before"
            afterLabel="After"
          />
        </div>
      </div>
    </div>
  );
}
